import * as React from 'react';
import * as styles from '../../Categories.css';
import { IAPanel } from '../../../panels/Panel';
import { IItemData } from '../../../../interfaces/ICategoryAdmin';
import { IAColorPicker } from '../../../colorPicker/ColorPicker';
import { IAButton } from '../../../button/Button';
import { Helper } from '../../../../Helper';
import { LocalizationService } from '../../../../services/LocalizationService';

export interface IProps {
  show: boolean;
  highlightColor: string;
  categoryToEditColors: IItemData
  onDismiss: () => void;
  onSave: (bgColor: string, textColor: string) => Promise<void>;
}

export interface IState {
  isSaving: boolean;
  backgroundColor: string;
  textColor: string;
}

export class IACategoryColorPanel extends React.Component<IProps, IState> {
  private readonly localizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      isSaving: false,
      backgroundColor: undefined,
      textColor: undefined
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentWillReceiveProps(props: IProps) {
    if (props.show !== this.props.show && props.show) {
      this.setState({
        isSaving: false,
        backgroundColor: props.categoryToEditColors.bgColor ?? "#ffffff",
        textColor: props.categoryToEditColors.textColor ?? Helper.getCategoriesDefaultTextColor()
      })
    }
  }

  public render(): JSX.Element {
    return (
      <IAPanel
        showNavigationBar={true}
        title={this.localizationService.strings.Categories_ChangeTheColor}
        open={this.props.show}
        transition="slide"
        isMobile={false}
        width={600}
        close={() => this.props.onDismiss()}
      >
        {this.props.categoryToEditColors && 
          <div style={{
            paddingLeft: 40,
            paddingRight: 40,
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column"
          }}>
            <div
              className={styles.IA_category}
              style={{
                backgroundColor: this.state.backgroundColor,
                color: this.state.textColor
              }}
            >
              {this.props.categoryToEditColors.name}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 20
              }}
            >
              <IAColorPicker
                label={this.localizationService.strings.Categories_BackgroundColor}
                color={this.state.backgroundColor}
                showClearButton={true}
                onChange={(color) => this.setState({ backgroundColor: color })}
              />
              <IAColorPicker
                label={this.localizationService.strings.Categories_TextColor}
                color={this.state.textColor}
                showClearButton={true}
                onChange={(color) => this.setState({ textColor: color ?? Helper.getCategoriesDefaultTextColor() })}
              />
            </div>
            <IAButton
              buttonColor={this.props.highlightColor}
              textColor="white"
              borderRadius={5}
              label={this.localizationService.strings.Admin_Save}
              showSpinner={this.state.isSaving}
              onClick={() => {
                this.setState({ isSaving: true }, () => this.props.onSave(this.state.backgroundColor, this.state.textColor).finally(() => this.props.onDismiss()));
              }}
            />
          </div>
        }
      </IAPanel>
    );
  }
}